<div>
    <div class="container-bienvenida">
        <div class="container-derecho" #containerDerecho>
            <h2 class="text-center quicksand-bold">{{datos.titulo_valor_curso}}</h2>
            <div class="container-aranceles">
                <h3 class="text-center  nunito-bold">{{datos.arancel | currency:undefined:"$"}}</h3>
                <div class="div-cuotas cuotas" *ngFor="let cuota of cuotas">
                    <div class="container-title">
                        <span class="quicksand-bold text-cuotas" style="color: #5A8ABE"> {{cuota.cant }} </span>
                        <span *ngIf="cuota.cant > 1" class=" quicksand-bold text-cuotas"
                            style="color: #5A8ABE">cuotas</span>
                        <span *ngIf="cuota.cant == 1" class=" quicksand-bold text-cuotas"
                            style="color: #5A8ABE">cuota</span>
                        <span class="" *ngIf="!datos.interes" class=" quicksand-bold text-cuotas"
                            style="color: #5A8ABE"> SIN INTERÉS</span>
                    </div>
                    <span *ngIf='cuota.valor' class=" nunito-medium valor-cuota" style="color: #5A8ABE">{{cuota.valor |
                        currency:undefined:"$"}}</span>

                </div>
            </div>

            <div class="mediosPago" *ngIf="isDesktop && !datos.curso_gratuito">
                <div>
                    <p class="quicksand-bold ">Medios de pago</p>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-center flex-wrap">
                    <img *ngFor="let mp of datos.general_data_obj?.metodos_pago" [src]="apiUrl + mp.image_course_uri"
                        alt="" class="metodos-pago">
                </div>
            </div>


            <div class="container-buttons">
                  <!-- datos.button_signUp_state -->
               

                <!-- <button class="btn-descuento nunito-regular zoomIn "><a target="_blank"
                        href="https://inscripcion.uca.edu.ar/">CONSULTAR DESCUENTOS Y BENEFICIOS</a></button> -->
            </div>



        </div>
        <!-- 
        <div class="container-izq" *ngIf="!isDesktop && video" #containerIzq>
          <div class="video-wrapper ">
            <iframe
              width="100%"
              height="100%"
              [src]="safeVideoUrl"
              frameborder="0"
              allowfullscreen>
            </iframe>
          </div>

        </div> -->
        <div class="img-container" #imgContainer>


            <div class="datosCursada">
                <div>
                    <img class='icon-cursada' src="./assets/img/icon-calnedario-fichas.png">
                </div>
                <div style="margin-left: 20px;">
                    <div>
                        <span class="nunito-bold text1">Inicio:</span>
                        <span *ngIf="datos.modality != 'Virtual - Asincrónico'" class="nunito-medium ml-2">{{datos.date_search_start}}</span>
                        <span *ngIf="datos.modality == 'Virtual - Asincrónico'" class="nunito-medium ml-2">Asincrónico</span>
                    </div>
                    <div *ngIf="datos.date_ending">
                        <span class="nunito-bold text1">Finalización:</span><span
                            class="nunito-medium ml-2 ">{{datos.date_ending}}</span>
                    </div>
                </div>
            </div>

            <div class="datosCursada" *ngIf="datos.coursed">
                <div>
                    <img class='icon-cursada' src="./assets/img/icon-cursada-fichas.png">
                </div>
                <div style="margin-left: 20px;">
                    <div>
                        <span class="nunito-bold text1">Cursada:</span><span
                            class="nunito-medium ml-2 ">{{datos.coursed}}</span>
                    </div>
                </div>
            </div>
            <div class="datosCursada" *ngIf="datos.modality">
                <div>
                    <img class='icon-cursada' src="./assets/img/icon-modalidad-fichas.png">
                </div>
                <div style="margin-left: 20px;">
                    <div>
                        <span class="nunito-bold text1">Modalidad:</span><span
                            class="nunito-medium ml-2 ">{{datos.modality}}</span>
                    </div>
                </div>
            </div>
            <div class="datosCursada" *ngIf="datos.workload">
                <div>
                    <img class='icon-cursada' src="./assets/img/icon-duracion-fichas.png">
                </div>
                <div style="margin-left: 20px;">
                    <div>
                        <span class="nunito-bold text1">Duración:</span><span
                            class="nunito-medium ml-2 ">{{datos.workload}}</span>
                    </div>
                </div>
            </div>
            <div class="directorDiv" *ngIf="datos.director">
                <span class="nunito-bold text1">Director:</span><span
                    class="nunito-medium ml-2 ">{{datos.director}}</span>

            </div>
            <!--<div class="linea"></div>
            <div class="divIcons">
                <a [href]="datos.whatsapp" Target="_blank">
                    <img class=" pointer redes" src="./assets/img/wsp-icon.png" alt="">
                </a>
                <a (click)="openModalConsulta()">
                    <img class=" pointer redes" src="./assets/img/msg-icon.png" alt="">
                </a>

                <a [href]="datos.facebook" Target="_blank" class="ml-4">
                    <img class=" pointer redes" src="./assets/img/facebook-icon.png" alt="">
                </a>
                <a [href]="datos.instagram" Target="_blank">
                    <img class=" pointer redes" src="./assets/img/ig-icon.png" alt="">
                </a>

            </div>
            <div class="linea"></div>-->

            <div class="buttons-aranceles">
                <button (click)="openModalConsulta()" *ngIf="datos.button_signUp_state"class="btn-aranceles1 nunito-medium zoomIn">QUIERO RECIBIR MÁS
                    INFORMACIÓN
                </button>

                <button *ngIf="datos.whatsapp" class="btn-aranceles2 nunito-medium zoomIn"
                    (click)="abrirWhatsApp(datos.whatsapp)">
                    WHATSAPP
                </button>



                <ng-container *ngFor="let btn of datos.buttonStudyPlan">
                    <button *ngIf="btn.type=='boton' && btn.state" (click)="openModal(btn)"
                        class="btn-aranceles1 nunito-medium zoomIn">{{btn.title}}</button>
                    <button *ngIf="btn.type=='link' && btn.state" (click)="openLink(btn)"
                        class="btn-aranceles1 nunito-medium zoomIn">{{btn.title}}</button>
                </ng-container>
                <!--<button class="btn-aranceles2 nunito-medium">CONSULTAR DESCUENTOS Y BENEFICIOS</button>-->
            </div>
        </div>
    </div>
</div>